import React, { ReactElement } from 'react';
import { Select, SelectProps } from 'antd';

import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { State } from 'types';

const { Option } = Select;

export const FieldLocation = (props: SelectProps<string>): ReactElement => {
  return (
    <Select<string>
      showSearch
      allowClear
      filterOption={(input, option) => {
        return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
      }}
      {...props}
    >
      {LeashContent?.states.map((state: State) => (
        <Option key={state.id} value={state.abbr}>
          {state.name}
        </Option>
      ))}
    </Select>
  );
};
